import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchPublishmentsData = createAsyncThunk(
    'publishments/fetchData',
    async ({ perPage ,page=1}) => {
        try {
            const response = await api.get('/publishments', {
                params: {
                    perPage: perPage,
                    page
                }
            });
            const data = { data: response.data.data, total: response.data.total };
            return data;
        } catch (error) {
            return error;
        }

    }
);

export const publishmentSlice = createSlice({
    name: "publishments",
    initialState: {
        loading: false,
        error: null,
        total: 0,
        publishments: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchPublishmentsData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchPublishmentsData.fulfilled, (state, action) => {
                state.loading = false;
                state.publishments = action.payload.data;
                state.total = action.payload.total;
            })
            .addCase(fetchPublishmentsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.total = 0;
            })
    }
});

export default publishmentSlice.reducer;